<template>
    <div v-show="carregado" id="layoutDefault">
        <div id="layoutDefault_content">
            <main>
                <topo :app="app" />

                <banner />

                <beneficios :app="app" />

                <abrir-empresa :app="app" />

                <atendimento
                    :atendimentos="dados.atendimentos"
                    :mensagemWhatsApp="dados.mensagemWhatsApp"
                />

                <trocar-contador :app="app" />

                <contato />

                <rodape
                    :app="app"
                    :atendimentos="dados.atendimentos"
                    :mensagemWhatsApp="dados.mensagemWhatsApp"
                    :loja="dados['request.data'].Loja"
                />
                <div v-html="css" />
            </main>
        </div>
    </div>
</template>
<script>
import Topo from './Topo'
import Banner from './Banner'
import Beneficios from './Beneficios'
import AbrirEmpresa from './AbrirEmpresa'
import Atendimento from './Atendimento'
import TrocarContador from './TrocarContador'
import Contato from './Contato'
import Rodape from './Rodape'
export default {
    components: {
        Topo,
        Banner,
        Beneficios,
        AbrirEmpresa,
        Atendimento,
        TrocarContador,
        Contato,
        Rodape,
    },
    props: {
        app: { type: Object },
        dados: { type: Object }
    },
    data() {
        return {
            carregado: false,
        }
    },
    computed: {
        css: function() {
            let css = ''
            css += '<style>'

            css += '.bg-gradient-primary-to-secondary {'
            css += 'background-color: #' + this.app.cor_primaria + ';'
            css +=
                'background-image: linear-gradient(135deg, #' +
                this.app.cor_secundaria +
                ' 0%, #' +
                this.app.cor_primaria +
                ' 100%);'
            css += '}'

            css += '.navbar-marketing.navbar-dark.navbar-scrolled {'
            css += 'background-color: #' + this.app.cor_primaria + '!important;'
            css += '}'

            css += '.btn-primary {'
            css += 'background-color: #' + this.app.cor_secundaria + ';'
            css += 'border-color: #' + this.app.cor_secundaria + ';'
            css += '}'

            css += '.btn-primary:hover {'
            css += 'background-color: #' + this.app.cor_primaria + ';'
            css += 'border-color: #' + this.app.cor_primaria + ';'
            css += '}'

            css += '.btn-primary:active {'
            css += 'background-color: #' + this.app.cor_secundaria + ';'
            css += 'border-color: #' + this.app.cor_primaria + ';'
            css += '}'

            css += '.btn-primary:focus {'
            css += 'background-color: #' + this.app.cor_secundaria + ';'
            css += 'border-color: #' + this.app.cor_secundaria + ';'
            css += 'box-shadow: 0 0 0 0.2rem #' + this.app.cor_secundaria + ';'
            css += '}'

            css += '.btn-primary.disabled, .btn-primary:disabled {'
            css += 'background-color: #' + this.app.cor_secundaria + ';'
            css += 'border-color: #' + this.app.cor_secundaria + ';'
            css += '}'

            css += '.btn-teal {'
            css += 'color: #fff;'
            css += 'background-color: #' + this.app.cor_secundaria + ';'
            css += 'border-color: #' + this.app.cor_secundaria + ';'
            css += '}'

            css += '.btn-teal:hover {'
            css += 'color: #fff;'
            css += 'background-color: #' + this.app.cor_primaria + ';'
            css += 'border-color: #' + this.app.cor_primaria + ';'
            css += '}'

            css += '.border-primary {'
            css += 'border-color: #' + this.app.cor_secundaria + '!important;'
            css += '}'

            css += '.text-primary {'
            css += 'color: #' + this.app.cor_secundaria + '!important;'
            css += '}'

            css += 'a.text-primary:hover, a.text-primary:focus {'
            css += 'color: #' + this.app.cor_primaria + '!important;'
            css += '}'

            css += '.border-secondary {'
            css += 'border-color: #' + this.app.cor_primaria + '!important;'
            css += '}'

            css += '.text-secondary {'
            css += 'color: #' + this.app.cor_primaria + '!important;'
            css += '}'

            css += 'a.text-secondary:hover, a.text-secondary:focus {'
            css += 'color: #' + this.app.cor_secundaria + '!important;'
            css += '}'

            css += '.border-teal {'
            css += 'border-color: #' + this.app.cor_secundaria + '!important;'
            css += '}'

            css += '.text-teal {'
            css += 'color: #' + this.app.cor_secundaria + '!important;'
            css += '}'

            css += 'a.text-teal:hover, a.text-teal:focus {'
            css += 'color: #' + this.app.cor_primaria + '!important;'
            css += '}'

            css += '.btn-outline-dark {'
            css += 'color: #' + this.app.cor_primaria + ';'
            css += 'border-color: #' + this.app.cor_primaria + ';'
            css += '}'

            css += '.btn-outline-dark:hover {'
            css += 'color: #fff;'
            css += 'background-color: #' + this.app.cor_secundaria + ';'
            css += 'border-color: #' + this.app.cor_secundaria + ';'
            css += '}'

            css += '.text-dark, .page-header-light .btn-link {'
            css += 'color: #' + this.app.cor_primaria + '!important;'
            css += '}'

            css +=
                'a.text-dark:hover, .page-header-light a.btn-link:hover, a.text-dark:focus, .page-header-light a.btn-link:focus {'
            css += 'color: #' + this.app.cor_secundaria + '!important;'
            css += '}'

            css += '.bg-dark {'
            css += 'background-color: #' + this.app.cor_primaria + '!important;'
            css += '}'

            css +=
                'a.bg-dark:hover, a.bg-dark:focus, button.bg-dark:hover, button.bg-dark:focus {'
            css +=
                'background-color: #' + this.app.cor_secundaria + '!important;'
            css += '}'

            css += '.error {'
            css += 'font-size: initial;'
            css += 'width: auto;'
            css += 'color: #' + this.app.cor_primaria + ';'
            css += 'margin-bottom: 4%;'
            css += '}'

            css += '.has-success .form-control {'
            css += 'border-color: #' + this.app.cor_primaria + ';'
            css += '-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);'
            css += 'box-shadow: inset 0 1px 1px rgba(0,0,0,.075);'
            css += '}'

            css += '.has-error .form-control {'
            css += 'border-color: #' + this.app.cor_secundaria + ';'
            css += '-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);'
            css += 'box-shadow: inset 0 1px 1px rgba(0,0,0,.075);'
            css += '}'

            css += '.atendimento-personalizado{'
            css += 'color: #' + this.app.cor_primaria + ';'
            css += '}'

            css += '.atendimento-personalizado:hover {'
            css += 'color: #' + this.app.cor_secundaria + ';'
            css += 'text-decoration: none;'
            css += '}'

            css += '</style>'
            return css
        }
    },
    async mounted() {
       await this.carregaScripts()
       await this.carregaCss()
       setTimeout(() => {
        this.carregado = true
       }, 300)
    },
    methods: {
        carregaCss() {
            const css = [
                '/layouts/site/contabilidade/css/aos.css',
                '/layouts/site/contabilidade/css/styles.css'
            ]
            css.map(s => {
                let link = document.createElement('link')
                link.setAttribute('rel', 'stylesheet')
                link.href = s
                document.head.appendChild(link)
            })
        },
        carregaScripts() {
            const scripts = [
                '/layouts/site/contabilidade/js/aos.js',
                '/layouts/site/contabilidade/js/vendor/jquery-1.12.3.min.js',
                '/layouts/site/contabilidade/js/feather.min.js',
                '/layouts/site/contabilidade/js/jquery.validate.js',
                '/layouts/site/contabilidade/js/jquery.mask.js',
                '/layouts/site/contabilidade/js/bootbox.js',
                '/layouts/site/contabilidade/js/bootstrap.bundle.min.js',
                '/layouts/site/contabilidade/js/font-awesome-5.11.2.min.js',
                '/layouts/site/contabilidade/js/scripts.js'
            ]
            scripts.map((s, i) => {
                setTimeout(() => {
                    let script = document.createElement('script')
                    script.setAttribute('src', s)
                    document.body.appendChild(script)

                    if (s == '/layouts/site/contabilidade/js/aos.js') {
                        script.onload = function() {
                            let aos = document.createElement('script')
                            aos.setAttribute('type', 'text/javascript')
                            aos.text =
                                "AOS.init({ disable: 'mobile', duration: 600, once: true });"
                            document.body.appendChild(aos)
                        }
                        
                    }
                }, i * 100)
            })
        }
    }
}
</script>
<style>
html {
    scroll-behavior: smooth;
}

#beneficios,
#atendimento,
#abrir-empresa,
#trocar-contador,
#contato {
    scroll-margin-top: 50px;
}

.img-logo {
    max-width: 25%;
    height: auto;
}

.grecaptcha-badge {
    visibility: hidden;
}

@media only screen and (max-width: 600px) {
    .img-logo {
        max-width: 60%;
        height: auto;
    }
}
</style>
